class logoSlider extends HTMLElement {
    constructor() {
        super();
        if (window.matchMedia("(max-width: 767px)").matches) {
          this.imgSlider()
        }
    }

    imgSlider = () => {
        var elem = this.querySelector('.logo-slider');
        new Swiper(elem, {
            spaceBetween: 0,
            centeredSlides: false,
            slidesPerView: 1,
            loop: true,
            speed: 1000,
            autoplay: {
              delay: 2000,
              disableOnInteraction: false,
            },
            breakpoints: {
                768: {
                  slidesPerView: 2
                },
                1199: {
                  slidesPerView: 3,
                  loop: false
                }
              }
          });

        // new Flickity(elem, {
        //     imagesLoaded: true,
        //     percentPosition: true,
        //     initialIndex: 1,
        //     cellAlign: 'center',
        //     autoPlay: 2500,
        //     wrapAround: true,
        //     pageDots: false,
        //     prevNextButtons: false
        // });
    }
}

customElements.define('logo-slider', logoSlider);